<div class="top">
Confirmation required
</div>
<div class="middle" [innerHTML]="data.message">
</div>
<div class="bottom">
    <button *ngIf="!data.hideCancelButton" mat-flat-button mat-dialog-close color="warn">Cancel</button>
    <button mat-flat-button class="confirm-btn" (click)="dialogRef.close(true)">Proceed</button>
</div>